import React from "react"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import Tabs from '../Tabs/Tabs'
import ReservationSettingPresenterTabContent from  "./ReservationSettingPresenterTabContent"


export default class ReservationSettingPresenter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        loading: false,
        check_in_time: this.props.reservation_setting.check_in_time|| null,
        check_out_time: this.props.reservation_setting.check_out_time || null,
        // minimum_stay: this.props.reservation_setting.minimum_stay || null,
        maximum_stay: this.props.reservation_setting.maximum_stay || null,
        date_format: this.props.reservation_setting.date_format || null,
        time_format: this.props.reservation_setting.time_format || null,
        app_time_format: this.props.app_time_format || null,
        time: this.props.time || null,
        auto_assign: this.props.reservation_setting.auto_assign,
        revert: this.props.revert,
        reservation_setting_revision_history_path: this.props.reservation_setting_revision_history_path,
        active_tab: 'general'
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  };

  componentDidMount() {
    var self = this
    $(window).on("reservationSettingSaved", function () {
      $.ajax({
        type: 'POST',
        url: '/admin/reservation-settings/data',
      }).done((data) => {
        self.setState({
          ...data.reservation_setting
        })
      })
    });
  }


  onChangeActiveTab(name) {
    this.setState({
      active_tab: name
    });
  };

  render() {
    var self = this;

    return (
      <div className="incidental-deposit-builder">
        <Tabs tabs={this.Tabs()} />
        <div className="panel panel-form">
          <ReservationSettingPresenterTabContent {...this.props} {...this.state} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  Tabs() {
    return (
      !this.props.revert
      ?
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('history'),
          targetName: 'history',
          classes: this.state.active_tab === 'history' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        }
      ]
      :
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );

  };

};
